import uploadsaboutpagebannerbgimageshutterstock_1092700045FirstFrameJpg from "$lib/data/generated/uploads/about/PageBanner/bgImage/shutterstock_1092700045-first-frame.jpg";
import uploadsaboutpagebannerbgvideoshutterstock_1092700045Mp4 from "$lib/data/generated/uploads/about/PageBanner/bgVideo/shutterstock_1092700045.mp4";

export const uploads = {
  "uploads/about/PageBanner/bgImage/shutterstock_1092700045-first-frame.jpg": uploadsaboutpagebannerbgimageshutterstock_1092700045FirstFrameJpg,
  "uploads/about/PageBanner/bgVideo/shutterstock_1092700045.mp4": uploadsaboutpagebannerbgvideoshutterstock_1092700045Mp4
};